import ZJApp from "../../../../app";

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
  service: "CarParkService",
  controller: "CarPark",
};

const methods = [
  "AddItem",
  "UpdateItem",
  "DelItem",
  "DelItemList",
  "GetCarParkById",
  "FindByConditions",
  "GetItemPagingList",
];

const factory = (Fun) => {
  utils.extend(Fun.prototype, info);
  methods.forEach((path) => {
    if (path == "GetCarParkById") {
      Fun.prototype[path] = function(data) {
        const getPath = "GetCarParkById?id=" + data;
        return this.get(getPath);
      };
    } else {
      Fun.prototype[path] = function(data) {
        return this.post(path, data);
      };
    }
  });
};

const CarParkApi = ZJApi.defineNewApi("CarParkApi", factory);

export default CarParkApi;
